import React, { useEffect, useState } from 'react';
import { MetaLabel, PlayfairHeading } from '../nobel';

export const TerminalLoader: React.FC = () => {
    const [text, setText] = useState('SYSTEM BOOT');
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) return 100;
                return prev + Math.floor(Math.random() * 15);
            });
        }, 150);

        const textInterval = setInterval(() => {
            const stages = ['SYSTEM BOOT', 'CHECKING BIO', 'CONNECTING', 'ESTABLISHING', 'CONNECTED'];
            setText(prev => {
                const currentIndex = stages.indexOf(prev);
                return stages[(currentIndex + 1) % stages.length];
            });
        }, 800);

        return () => {
            clearInterval(interval);
            clearInterval(textInterval);
        };
    }, []);

    return (
        <div className="flex flex-col items-center justify-center h-full w-full bg-[var(--bg-cream)] text-[var(--color-stone-900)]">
            <div className="w-64 space-y-4">
                <div className="flex justify-between items-end">
                    <MetaLabel>TERMINAL ACCESS</MetaLabel>
                    <span className="font-mono text-xs">{progress}%</span>
                </div>

                {/* Progress Bar */}
                <div className="h-1 w-full bg-[var(--color-stone-200)]">
                    <div
                        className="h-full bg-[var(--color-nobel-gold)] transition-all duration-300"
                        style={{ width: `${progress}%` }}
                    />
                </div>

                <div className="text-center pt-2">
                    <PlayfairHeading size="lg" className="italic animate-pulse">
                        {text}...
                    </PlayfairHeading>
                </div>
            </div>
        </div>
    );
};
